<script>
export default {
  name: 'icon-delete',
  props: {
    reverse: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#ffffff',
    },
    noCircle: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#00A5EE',
    },
  },
}
</script>

<template>
  <svg
    :width="noCircle ? 14 : 40"
    :height="noCircle ? 20 : 40"
    :viewBox="noCircle ? `0 0 14 20` : `0 0 40 40`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      v-if="!noCircle"
      cx="20"
      cy="20"
      r="19"
      :fill="reverse ? color : backgroundColor"
      stroke="#DEDEDE"
      stroke-width="2"
    />
    <path
      v-if="!noCircle"
      d="M27.1636 11.1667H24.2475L23.0811 10H17.2489L16.0825 11.1667H13.1664C12.5249 11.1667 12 11.6917 12 12.3333C12 12.975 12.5249 13.5 13.1664 13.5H27.1636C27.8051 13.5 28.33 12.975 28.33 12.3333C28.33 11.6917 27.8051 11.1667 27.1636 11.1667Z"
      :fill="reverse ? backgroundColor : color"
    />
    <path
      v-if="!noCircle"
      d="M13.1665 28.6666C13.1665 29.95 14.2163 31 15.4994 31H24.8308C26.1139 31 27.1636 29.95 27.1636 28.6666V14.6666H13.1665V28.6666ZM23.4777 17.1283H24.8774V27.6283H23.4777V17.1283ZM19.4652 17.1283H20.8649V27.6283H19.4652V17.1283ZM15.4527 17.1283H16.8524V27.6283H15.4527V17.1283Z"
      :fill="reverse ? backgroundColor : color"
    />
    <path
      v-if="noCircle"
      d="M13 1.99837H10.5L9.5 0.998169H4.5L3.5 1.99837H1C0.45 1.99837 0 2.44846 0 2.99858C0 3.54869 0.45 3.99878 1 3.99878H13C13.55 3.99878 14 3.54869 14 2.99858C14 2.44846 13.55 1.99837 13 1.99837Z"
      :fill="reverse ? backgroundColor : color"
    />
    <path
      v-if="noCircle"
      d="M1.00006 17.0014C1.00006 18.1016 1.90006 19.0018 3.00006 19.0018H11.0001C12.1001 19.0018 13.0001 18.1016 13.0001 17.0014V4.9989H1.00006V17.0014ZM9.84006 7.10933H11.0401V16.1112H9.84006V7.10933ZM6.40006 7.10933H7.60006V16.1112H6.40006V7.10933ZM2.96006 7.10933H4.16006V16.1112H2.96006V7.10933Z"
      :fill="reverse ? backgroundColor : color"
    />
  </svg>
</template>
